module.exports = __webpack_public_path__ + "static/share-master-small-46dbe39af6891b8dcbd2c59a3aa5275d.png";